import React from 'react'
import Main from '../components/SubscriptionDetails/Main'
import PaginationContextProvider from '../store/pagination-context'


const SubscriptionDetails = () => {
    return (
        <PaginationContextProvider>
            <Main />
        </PaginationContextProvider>
    )
}

export default SubscriptionDetails
